const loading_card = {
	description: "Dit kan een paar minuten duren",
	title: "Uw VPS wordt aangemaakt...",
};

export default loading_card;
